import { km, reais } from "./api";

/**
 * "O que falta para o anúncio vender", montado com o que o servidor devolve em
 * /meta-ads/situacao. Cada passo: { id, ok, titulo, detalhe, acao?, rotuloAcao? }.
 * `acao` é um de: "mapa", "recarga", "gerenciador", "link".
 */
const CONTA_ATIVA = 1;
const plural = (n, um, varios) => `${n} ${n === 1 ? um : varios}`;

function passoDaArea(c) {
  if (c.latitude != null && c.longitude != null) {
    return { id: "area", ok: true, titulo: "Endereço e raio do anúncio", detalhe: `${km(c.raio_km)} em volta da loja`, acao: "mapa", rotuloAcao: "Ajustar" };
  }
  return { id: "area", ok: false, titulo: "Marque a loja no mapa", detalhe: "Não achamos o endereço cadastrado. O pino é o centro do raio do anúncio.", acao: "mapa", rotuloAcao: "Marcar no mapa" };
}

function passoDoDinheiro(c, minimo) {
  if (c.conta_status != null && c.conta_status !== CONTA_ATIVA) {
    return { id: "dinheiro", ok: false, titulo: "A conta de anúncio está com pendência na Meta", detalhe: "Enquanto não for resolvida, nenhum anúncio roda.", acao: "gerenciador", rotuloAcao: "Abrir o Gerenciador" };
  }
  if (c.pre_paga) {
    if (c.saldo_centavos != null && c.saldo_centavos < minimo) {
      return { id: "dinheiro", ok: false, titulo: `Saldo de anúncios: ${reais(c.saldo_centavos)}`, detalhe: "A conta é pré-paga: sem saldo o anúncio não roda. A recarga é por Pix, na Meta.", acao: "recarga", rotuloAcao: "Recarregar por Pix" };
    }
    return { id: "dinheiro", ok: true, titulo: "Saldo para anunciar", detalhe: c.saldo_centavos == null ? "Conta pré-paga" : `${reais(c.saldo_centavos)} na conta pré-paga`, acao: "recarga", rotuloAcao: "Recarregar" };
  }
  if (!c.tem_pagamento) {
    return { id: "dinheiro", ok: false, titulo: "Cadastre uma forma de pagamento na Meta", detalhe: "Sem cartão ou Pix cadastrado nenhum anúncio roda.", acao: "recarga", rotuloAcao: "Abrir pagamentos" };
  }
  return { id: "dinheiro", ok: true, titulo: "Forma de pagamento cadastrada", detalhe: "A Meta cobra o anúncio direto da conta" };
}

function passoDoLink(link, campanhasNucleo) {
  const cliques = Number(link?.cliques || 0);
  const pedidos = Number(link?.pedidos || 0);
  if (cliques > 0 || pedidos > 0) {
    return { id: "link", ok: true, titulo: "Anúncio usando o link do cardápio", detalhe: `${plural(cliques, "clique", "cliques")} e ${plural(pedidos, "pedido", "pedidos")} pelo link do anúncio`, acao: "link", rotuloAcao: "Ver o link" };
  }
  // Campanha criada pelo Núcleo (Impulsionar) já nasce com o link: nada a fazer.
  if (campanhasNucleo > 0) {
    return { id: "link", ok: true, titulo: "Suas campanhas já levam o link do cardápio", detalhe: "O anúncio criado aqui marca o pedido sozinho. O link abaixo é para anúncio feito fora do Núcleo.", acao: "link", rotuloAcao: "Ver o link" };
  }
  return { id: "link", ok: false, titulo: "Crie o anúncio aqui, ou coloque o link no anúncio de fora", detalhe: "Em Impulsionar o anúncio já nasce com o link. No Gerenciador ou no Instagram, é ele que marca o pedido como vindo do anúncio.", acao: "link", rotuloAcao: "Ver o link" };
}

export function montarPassos(situacao) {
  const c = situacao?.conexao || {};
  const passos = [
    { id: "conta", ok: true, titulo: "Conta conectada", detalhe: [c.ad_account_nome, c.page_nome].filter(Boolean).join(" · ") },
    passoDaArea(c),
    passoDoDinheiro(c, situacao?.saldo_minimo_centavos ?? 2000),
    passoDoLink(situacao?.link_anuncio, Number(situacao?.campanhas_nucleo || 0)),
  ];
  if (situacao?.instagram_legivel && !c.instagram_username) {
    passos.push({ id: "instagram", ok: false, titulo: "Ligue o Instagram à Página", detalhe: `No Instagram: Editar perfil → Página → conectar a "${c.page_nome}". Sem isso o anúncio sai só com o nome da Página.` });
  }
  return passos;
}
